import settings from './../../config.js';

const nameStyle = settings.treeNameStyle ? settings.treeNameStyle : 'DEFAULT';
const ID_OBJECT = 'idobject';
const AID_SCHEME = 'anleggsid';
const PARAMETER_NAME = 'parametername';
const VALUE = 'value';

export function getInitialIdPlant() {
  return new Promise((resolve, reject) => {

    var scheme = '';

    if (window.location.search.toLowerCase().indexOf(AID_SCHEME) > -1) {
      scheme = AID_SCHEME;
    } else if (window.location.search.toLowerCase().indexOf(ID_OBJECT) > -1) {
      scheme = ID_OBJECT;
    } else if (window.location.search.toLowerCase().indexOf(PARAMETER_NAME) > -1 && (window.location.search.toLowerCase().indexOf(VALUE) > -1)) {
      scheme = PARAMETER_NAME;
    }

    switch (scheme) {
      case AID_SCHEME:
        const idPlant = getParameterByName(AID_SCHEME);
        resolve([idPlant]);
        break;
     default:
        resolve(null);
        break;
    }
  });
}

function getParameterByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  let results = regex.exec(location.search.toLowerCase());
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}



/** WEBPACK FOOTER **
 ** app/components/common/url-schemes.js
 **/